import { useState } from "react";
import { convertStringToTitleCase } from "../../common/commonHelper";
import { PeriodSwitch } from "../controls/periodSwitch";
import { IconTypes, RenderIcons } from "../controls/icons";






const _props = {
  title: "",
  renderWithPeriod: (period) => {
    return <></>;
  },
  resetData: <></>,
  chartConfig: {},
  categorySwitch: <></>,
};
  
export function ChartArea(props = _props) {

  const options = props.chartConfig?.period?.options?.map(x=>convertStringToTitleCase(x));
  const [period, setPeriod] = useState(convertStringToTitleCase(props.chartConfig?.period?.default));
  const children = props.renderWithPeriod
    ? props.renderWithPeriod(period)
    : props.children;
  return (
    <div className="graph-panel">
      <div className="chart-title-main">
        <div className="row mb-2">
<div className="col-md-9 chart_heading"><strong className="chart-title">{props.title}</strong></div>

<div className="col-md-3">{props.resetData}</div>
</div>
<div className="row">
          <div className="col-md-5 pr-0">
            
            <span>
            {props.renderWithPeriod && props.chartConfig.period ? (
              <PeriodSwitch
                selectedPeriod={period}
                placeholder="Period"
                setPeriod={setPeriod}
                periodOptions={options}
              />
            ) : (
              <></>
            )}
            
            </span>
            
          </div>
          <div className="col-md-3 offset-md-4 pl-0 select_category_drop">
          {props.categorySwitch}        
            
          </div>
        </div>
      </div>
      {children}
    </div>
  );
  
}

